import { observer } from 'mobx-react'
import React from 'react'
import DecorationMobx from '@mobx/app/decoration.mobx'
import { memberMobx, activityMobx } from '@mobxStore'
import { AvatarModal } from '@cps'
import { modalLayer, useHistoryNew, getPlatform, miniAppRouteTo } from '@utils'
import mktController from 'controllers/mktController'
import { getNickName } from '@common/utils/member'
import './index.scss'

import memberImg from '@img/member/member.png'

const { isWeixinMiniProgram } = getPlatform()

interface IProps { }

const HeaderModule: React.FC<IProps> = (props: IProps) => {
  const history = useHistoryNew()
  const { memberInfo } = memberMobx
  const { nickName, avatarUrl, email, mobile } = memberInfo
  const {
    mktDecorates
  } = DecorationMobx
  const changeAvatar = () => {
    if (memberInfo.type !== 'member') {
      mktController.jumpBind(history, 'all')
    } else {
      modalLayer(AvatarModal, { data: avatarUrl, name: nickName }).then((val: any) => {
        memberMobx.updateMemberInfo({
          avatarUrl: val || '',
        })
      })
    }
  }
  const handleGo = (e: any, path: string, needLogin?: boolean, needMember?: boolean) => {
    e && e.stopPropagation()
    mktController.checkLogin(history, needLogin, needMember).then(() => {
      if (path) history.push(path)
    })
  }
  const handleGetInfo = () => {
    miniAppRouteTo('/pages/improveInfo/index')
  }
  const showGet = () => {
    return isWeixinMiniProgram && Config.miniVersion >= 102221122
  }
  return (
    <div className={mktDecorates?.memberTemp === 'newplan' ? 'new-header-panel' : 'header-panel'}>
      {
        !memberMobx.isLogin && (
          <div className='haslog-content' style={{ color: mktDecorates.member.fontColor }} data-cypid='myToLogin' onClick={(e: any) => handleGo(e, '', true, false)}>
            <div className='haslog-l'>
              <div className='avatar'>
                <div className='avatar-img' style={{ backgroundImage: `Url(${memberImg})` }}></div>
              </div>
              <div className='login-info'>
                <div className='title'>{i18n.t('mkt.member.signNow')}</div>
                <div className='des'>{getNickName(memberInfo.nickName)}</div>
              </div>
            </div>
          </div>
        )
      }
      {
        memberMobx.isLogin && (
          <div className='haslog-content' style={{ color: mktDecorates.member.fontColor }}>
            <div className='haslog-l'>
              {
                avatarUrl ? (
                  <div className='avatar' data-cypid='myToAvatar' onClick={changeAvatar}>
                    <div className='avatar-img' style={{ backgroundImage: `Url(${avatarUrl})` }}></div>
                  </div>
                ) : (
                  <>
                    {
                      nickName ? (
                        <div className='avatar' data-cypid='myToAvatar' onClick={changeAvatar}>
                          <span>{nickName?.charAt(0)?.toUpperCase()}</span>
                        </div>
                      ) : (
                        <div className='avatar' data-cypid='myToAvatar' onClick={changeAvatar}>
                          <div className='avatar-img' style={{ backgroundImage: `Url(${memberImg})` }}></div>
                        </div>)
                    }
                  </>
                )
              }
              <div className='login-info'>
                <div className='title'>
                  <div data-cypid='myToSetting' onClick={(e: any) => handleGo(e, '/my/setting', true, false)}>{getNickName(nickName)}</div>
                  {
                    mktDecorates?.memberTemp !== 'newplan' && showGet() &&
                      <div
                        onClick={handleGetInfo}
                        className='use-mini'
                      >{i18n.t('mkt.member.useWeChatAn')}
                      </div>
                  }
                </div>
                {
                  !mobile && !email
                    ? (
                      <div data-cypid='mmgToBindMobile' className='des' onClick={(e: any) => mktController.checkMobileBindBalance(history)}>
                        <span>{activityMobx.bindMobileActive ? i18n.t('mkt.member.bindMobileCoupon') : i18n.t('mkt.member.guideBinding')}</span>
                        <i className='iconfont icon-chevron-right'></i>
                      </div>
                    )
                    : (
                      <div data-cypid='mmgToBindSetting' className='des' onClick={(e: any) => handleGo(e, '/my/setting', true, true)}>
                        <span>{mobile || email}</span>
                        <i className='iconfont icon-chevron-right'></i>
                      </div>)
                }
                {
                  mktDecorates?.memberTemp === 'newplan' && showGet() &&
                    <div
                      data-cypid='mmgGetWxUserInfo'
                      onClick={handleGetInfo}
                      className='use-mini'
                    >{i18n.t('mkt.member.useWeChatAn')}
                    </div>
                }
              </div>
            </div>
          </div>
        )
      }
    </div>
  )
}

export default observer(HeaderModule)
